import script from "./Advisors.vue?vue&type=script&setup=true&lang=js"
export * from "./Advisors.vue?vue&type=script&setup=true&lang=js"

import "./Advisors.vue?vue&type=style&index=0&id=6804d9ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6804d9ad"]])

export default __exports__